import { createStructuredSelector } from "reselect";
import {
    REPORT_BUGS_USER_LIST,
    REPORT_BUGS_USER_LIST_SUCCESS,
    REPORT_BUGS_USER_LIST_ERROR,
    REPORT_BUGS_MENU,
    REPORT_BUGS_MENU_SUCCESS,
    REPORT_BUGS_MENU_ERROR,
    REPORT_BUGS_RESOURCE,
    REPORT_BUGS_RESOURCE_SUCCESS,
    REPORT_BUGS_RESOURCE_ERROR,
    REPORT_BUGS_BY_USER,
    REPORT_BUGS_BY_USER_SUCCESS,
    REPORT_BUGS_BY_USER_ERROR,
    REPORT_BUGS_PAGE_SET,
    REPORT_BUGS_ADD_MODAL_SET,
    REPORT_BUGS_ADD_CHANGE_SET,
    REPORT_BUGS_ADD,
    REPORT_BUGS_ADD_SUCCESS,
    REPORT_BUGS_ADD_ERROR,
    REPORT_BUGS_CANCEL,
    REPORT_BUGS_CANCEL_SUCCESS,
    REPORT_BUGS_CANCEL_ERROR,
    REPORT_BUGS_APPROVED,
    REPORT_BUGS_APPROVED_SUCCESS,
    REPORT_BUGS_APPROVED_ERROR,
    REPORT_BUGS_LIST,
    REPORT_BUGS_LIST_SUCCESS,
    REPORT_BUGS_LIST_ERROR
} from "../actions";

export const NAME = 'reportBugs';

export const ReportBugsUserList = (data) => ({
    type: REPORT_BUGS_USER_LIST,
    payload: data
});

export const ReportBugsUserListSuccess = (data) => ({
    type: REPORT_BUGS_USER_LIST_SUCCESS,
    payload: data
});

export const ReportBugsUserListError = (error) => ({
    type: REPORT_BUGS_USER_LIST_ERROR,
    payload: error
});

export const ReportBugsMenu = (data) => ({
    type: REPORT_BUGS_MENU,
    payload: data
});

export const ReportBugsMenuSuccess = (data) => ({
    type: REPORT_BUGS_MENU_SUCCESS,
    payload: data
});

export const ReportBugsMenuError = (error) => ({
    type: REPORT_BUGS_MENU_ERROR,
    payload: error
});

export const ReportBugsResource = (data) => ({
    type: REPORT_BUGS_RESOURCE,
    payload: data
});

export const ReportBugsResourceSuccess = (data) => ({
    type: REPORT_BUGS_RESOURCE_SUCCESS,
    payload: data
});

export const ReportBugsResourceError = (error) => ({
    type: REPORT_BUGS_RESOURCE_ERROR,
    payload: error
});

export const ReportBugsByUser = (page, num_page, orderBy, filters, stateFilter) => ({
    type: REPORT_BUGS_BY_USER,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ReportBugsByUserSuccess = (data) => ({
    type: REPORT_BUGS_BY_USER_SUCCESS,
    payload: data
});

export const ReportBugsByUserError = (error) => ({
    type: REPORT_BUGS_BY_USER_ERROR,
    payload: error
});

export const ReportBugsPageSet = (data) => ({
    type: REPORT_BUGS_PAGE_SET,
    payload: data
});

export const ReportBugsAddModalSet = (data) => ({
    type: REPORT_BUGS_ADD_MODAL_SET,
    payload: data
});

export const ReportBugsAddChangeSet = (data) => ({
    type: REPORT_BUGS_ADD_CHANGE_SET,
    payload: data
});

export const ReportBugsAdd = (page, num_page, filters, data) => ({
    type: REPORT_BUGS_ADD,
    payload: { page: page, num_page: num_page, filters: filters, data: data }
});

export const ReportBugsAddSuccess = (message) => ({
    type: REPORT_BUGS_ADD_SUCCESS,
    payload: message
});

export const ReportBugsAddError = (error) => ({
    type: REPORT_BUGS_ADD_ERROR,
    payload: error
});

export const ReportBugsCancel = (page, num_page, filters, data) => ({
    type: REPORT_BUGS_CANCEL,
    payload: { page: page, num_page: num_page, filters: filters, data: data }
});

export const ReportBugsCancelSuccess = (message) => ({
    type: REPORT_BUGS_CANCEL_SUCCESS,
    payload: message
});

export const ReportBugsCancelError = (error) => ({
    type: REPORT_BUGS_CANCEL_ERROR,
    payload: error
});

export const ReportBugsApproved = (page, num_page, filters, data) => ({
    type: REPORT_BUGS_APPROVED,
    payload: { page: page, num_page: num_page, filters: filters, data: data }
});

export const ReportBugsApprovedSuccess = (message) => ({
    type: REPORT_BUGS_APPROVED_SUCCESS,
    payload: message
});

export const ReportBugsApprovedError = (error) => ({
    type: REPORT_BUGS_APPROVED_ERROR,
    payload: error
});

export const ReportBugsList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: REPORT_BUGS_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ReportBugsListSuccess = (data) => ({
    type: REPORT_BUGS_LIST_SUCCESS,
    payload: data
});

export const ReportBugsListError = (error) => ({
    type: REPORT_BUGS_LIST_ERROR,
    payload: error
});

const reportBugs = (state) => state[NAME];

export const ReportBugsSelector = createStructuredSelector({
    reportBugs
})

